import { notificationToast, toast } from '@gmg/gmg-react-components';
import { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import AppContext from 'src/AppContext';
import { getErrorMsgForToast, getErrorMsgFromLicenseSystemSubscription } from 'src/components/toastErrorHandler';
import { useRepairLicenseSystem } from 'src/graphql/useRepairLicenseSystem';
import { decodeBase64 } from 'src/shared/base64Utils';
import { getRepairLicenseSystemEvent } from 'src/tracking';
import { LicenseSystemSubscriptionViewModel } from 'src/viewModels/LicenseSystem';
import { createOrReactivateLicenseSystemSubscriptionResponseHandler } from '../addNewLicenseSystemToOrg/createOrReactivateLicenseSystemSubscriptionResponseHandler';
import RepairLicenseSystemModal from './RepairLicenseSystemModal';
import { RepairLicenseSystemNotificationToast, repairLicenseSystemNotificationToastId } from './RepairLicenseSystemNotificationToast';

export interface RepairLicenseSystemModalContainerProps {
    onClose?: () => void;
    selectedLicenseSystemId: string;
};

const RepairLicenseSystemModalContainer: FunctionComponent<RepairLicenseSystemModalContainerProps> = (props) => {
    const { t } = useTranslation();
    const params = useParams();
    const { trackEvent } = useContext(AppContext);
    const onSubscriptionResponse = (args: LicenseSystemSubscriptionViewModel) => {
        const argsWithErrorMessage = {
            ...args,
            error: args.error
                ? getErrorMsgFromLicenseSystemSubscription(args.error.errorType, args.licenseSystemId, t)
                : undefined,
        };
        createOrReactivateLicenseSystemSubscriptionResponseHandler({
            ...argsWithErrorMessage,
            toBeClosedToastIds: [repairLicenseSystemNotificationToastId],
            notificationTitle: t('SuccessNotificationWithDownloadLink.reactivation_notification_title', 'Repair file ready for download'),
            decoderFn: decodeBase64,
        });
    };

    const showRepairLicenseSystemNotificationToast = () => {
        notificationToast({
            content: <RepairLicenseSystemNotificationToast />,
            id: repairLicenseSystemNotificationToastId,
        });
    };
    const repairLicenseSystem = useRepairLicenseSystem({
        orgId: params.orgId!,
        onMutationStart: showRepairLicenseSystemNotificationToast,
        onSubscriptionResponse,
        selectedLicenseSystemId: props.selectedLicenseSystemId,
    });

    const handleSubmit = async (fileContent: string) => {
        try {
            trackEvent(getRepairLicenseSystemEvent());
            await repairLicenseSystem.mutateAsync(fileContent);

        } catch (error) {
            toast.error(getErrorMsgForToast(error, t));
        }
    };

    return (
        <RepairLicenseSystemModal
            onSubmit={(file: string) => handleSubmit(file)}
            onClose={props.onClose}
        />
    );
};

export default RepairLicenseSystemModalContainer;